<template>
  <div>
    <el-dialog
      class="modal"
      title="導出數據"
      :visible.sync="exportModal"
      width="375px"
    >
      <p class="text-danger text-center">最多導出七日數據</p>
      <el-date-picker
        style="width:100%;margin:10px 0;"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="exportDate"
        type="datetimerange"
        range-separator="至"
        start-placeholder="開始日期"
        end-placeholder="結束日期"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="{ disabledDate: $store.state.disabledDate }"
      >
      </el-date-picker>
      <el-input
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
        placeholder="用戶號"
        v-model="exportId"
        autocomplete="off"
      ></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="exportModal = false" class="btn">關閉</div>
        <div @click="confirmExport" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="">
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="currentDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="開始日期"
          end-placeholder="結束日期"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="{ disabledDate: $store.state.disabledDate }"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="用戶號">
        <el-input
          v-model="searchData.target_id"
          placeholder="用戶號"
        ></el-input>
      </el-form-item>
      <el-form-item label="訂單編號">
        <el-input
          v-model="searchData.transaction_id"
          placeholder="訂單編號"
        ></el-input>
      </el-form-item>
      <el-form-item label="類型">
        <el-select v-model="searchData.type" placeholder="類型">
          <el-option label="全部" value=""> </el-option>
          <el-option
            v-for="(log, key) in logsList"
            :key="key"
            :label="log"
            :value="key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <div class="export">
      <el-button size="mini" @click="exportData">導出數據</el-button>
    </div>
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <af-table-column
        header-align="center"
        align="center"
        prop="id"
        label="訂單編號"
        width="200px"
        :key="1"
      >
        <template slot-scope="scope">
          <el-tooltip
            style="cursor:pointer"
            v-clipboard:copy="scope.row.transaction_id"
            v-clipboard:success="$onCopy"
            class="item copyHover"
            effect="dark"
            content="點擊複製"
            placement="top"
          >
            <p>
              {{ scope.row.transaction_id }}
            </p>
          </el-tooltip>
        </template>
      </af-table-column>
      <af-table-column
        :key="2"
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
        header-align="center"
        align="center"
        prop="user_id"
        label="用戶號"
      >
      </af-table-column>
      <af-table-column
        :key="3"
        header-align="center"
        align="center"
        prop="type"
        label="操作類型"
      >
      </af-table-column>
      <af-table-column
        :key="4"
        width="130"
        header-align="center"
        align="right"
        label="原金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.balance_original | decimalPoint | thousands }}
          </div>
        </template>
      </af-table-column>
      <af-table-column
        :key="5"
        width="130"
        header-align="center"
        align="right"
        label="變動金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.balance_alter | decimalPoint | thousands }}
          </div>
        </template>
      </af-table-column>
      <af-table-column
        :key="6"
        width="130"
        header-align="center"
        align="right"
        label="變動後金額"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.balance_changed | decimalPoint | thousands }}
          </div>
        </template>
      </af-table-column>
      <af-table-column
        :key="7"
        header-align="center"
        align="center"
        prop="channel"
        label="交易渠道"
      >
      </af-table-column>
      <af-table-column
        :key="8"
        header-align="center"
        align="center"
        prop="created_at"
        label="訂單變動日期時間"
        width="180"
      >
      </af-table-column>
      <af-table-column
        :key="9"
        header-align="center"
        align="center"
        prop="note"
        label="備註"
      >
      </af-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      searchData: {},
      saveData: false,
      currentDate: [],
      pagination: {},
      dataList: [],
      inSearch: false,
      logsList: [],
      exportDate: [],
      exportId: "",
      exportModal: false
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    confirmExport() {
      let sendData;
      if (this.saveData) {
        sendData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        sendData = {};
      }
      sendData.exportId = this.exportId;
      if (!this.exportDate[0]) {
        this.$message.error("請選擇日期");
        return;
      }
      if (!this.exportId) {
        if (
          this.$store.state.userStatus != "customer" &&
          this.$store.state.userStatus != "customerSub"
        ) {
          this.$message.error("請輸入用戶號");
          return;
        }
      }
      if (this.exportDate[0]) {
        sendData.date_start = this.exportDate[0];
        sendData.date_end = this.exportDate[1];
      }
      sendData.target_id = this.exportId;
      this.$http
        .get(`/back/accounting/changelogs/export`, {
          params: sendData
        })
        .then(res => {
          if (res.data.code == 0) {
            window.open(`/back/export/${res.data.data}`);
          }
        });
    },
    exportData() {
      this.exportModal = true;
      this.exportId = "";
      this.exportDate = [];
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .post(`/back/accounting/changelogs/search`, searchData)
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
    this.$http.get(`/back/accounting/changelogs/type`).then(res => {
      if (res.data.code == 0) {
        this.logsList = res.data.data;
      }
    });
  }
};
</script>
